//action
import{
    RESET_PASSWORD,
    RESET_PASSWORD_FAIL,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_RESET
} from "../action/resetPasswordAction"
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        
        case RESET_PASSWORD:
            return {
                ...state,
                apiState: "loading"
            }
        case RESET_PASSWORD_FAIL:
            console.log("updatereducerfail")
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case RESET_PASSWORD_SUCCESS:
            console.log("upreducer",action.response)
            return {
                ...state,
                apiState: "success",
                data: action.response,
                message: action.response && action.response.data && action.response.data.message || api_err_msg
            }
        case RESET_PASSWORD_RESET:
            return initialState
        default:
            return state
        }
}